import { render, staticRenderFns } from "./AddressListItemSimpleCard.vue?vue&type=template&id=1eada51a&scoped=true"
import script from "./AddressListItemSimpleCard.vue?vue&type=script&lang=js"
export * from "./AddressListItemSimpleCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eada51a",
  null
  
)

export default component.exports